<template>
    <div class="flex-box flex-align-items-center gl-hover-text-purple vm-like hover-bg-purple" @click="like_action">
        <i class="afd mr4 red fs20"
           :class="{'afd-heart-filled': data.has_like, 'afd-heart': !data.has_like}"></i>
        <span :class="{red: data.has_like, 'black-3':!data.has_like}">{{data.like_count}}</span>
    </div>
</template>

<script>
import {
    POST_POST_LIKE,
    POST_POST_UNLIKE,
    POST_COMMENT_LIKE,
    POST_COMMENT_UNLIKE,
} from '@/api/config'
export default {
    name: 'like',
    props: {
        data: {
            type: Object,
            default(){
                return {}
            }
        }
    },
    data() {
        return {
        };
    },
    computed:{
        post_data(){
            let data = {}
            if(this.data.post_id){
                data.post_id =  this.data.post_id
            }
            if(this.data.comment_id){
                data.comment_id =  this.data.comment_id
            }
            return data
        },
        api(){
            let api = {}
            if(this.data.post_id){
                api = this.data.has_like ? POST_POST_UNLIKE : POST_POST_LIKE
            }
            if(this.data.comment_id){
                api = this.data.has_like ? POST_COMMENT_UNLIKE : POST_COMMENT_LIKE
            }
            return api
        },
    },
    mounted() {
    },
    methods: {
        async like_action(){
            if (this.$http.is_run(this.api)) {
                return false
            }
            let data = await this.$http.$axios(this.api, this.post_data)

            if(data.ec != 200){
                this.$notify({
                    title: data.em,
                    group: 'error',
                })
                return false
            }
            if(this.data.has_like){
                this.$emit('unlike_success', this.post_data)
            }
            else{
                this.$emit('like_success', this.post_data)
            }
        },
    }
};
</script>

<style lang="stylus" scoped>
.vm-like{
    font-size fs2rem(14)
    .afd{
        font-size fs2rem(14)
    }

}
</style>
